
import Datetime from 'vux/src/components/datetime/index.vue'
import Group from 'vux/src/components/group/index.vue'

import Moment from 'moment'
export default {
components: {
Datetime,
Group
},
props: {
placeholder: {
type: String,
default: ''
}
},
data () {
return {
value: Moment().format('YYYY-MM-DD HH:mm')
}
},
mounted () {
this.$emit('input', this.value)
},
watch: {
value (v) {
this.$emit('input', v)
}
}
}



// WEBPACK FOOTER //
// ./src/component/uiDate.vue